import CommonHeaderInner from '@/components/CommonHeaderInner/CommonHeaderInner';
import Seo from '@/components/Seo/Seo';
import WhatPeopleSay from '@/components/WhatPeopleSay/WhatPeopleSay';
import assest from '@/json/assest';
import Wrapper from '@/layout/wrapper/Wrapper';
import CustomButton from '@/ui/Buttons/CustomButton';
import { Box, Button, Container, Dialog, Grid, Paper, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import Image from 'next/image';
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';

const ServiceWrapper = styled(Box)`
    
`

const ServiceHeading = styled(Box)`
    text-align: center;

    .MuiTypography-body1 {
        width: 100%;    
        /* max-width: 756px; */
        max-width: 700px;
        margin: 0 auto;
    }
`

const AuthorPaper = styled(Paper)`
  padding: 30px 25px;
  box-shadow: 0px 34px 54px rgba(0, 0, 0, 0.03);
  border-radius: 20px;
  z-index: 1;
  position: relative;
  width: 100%;
  max-width: 92%;
  margin: -50px auto 0;
  /* min-height: 228px; */

  @media (max-width: 1199px) {
    padding: 15px;
  }

  .MuiTypography-h3 {
    font-weight: 500;
    font-size: 18px;  
    text-transform: capitalize;
    color: #000000;
    line-height: 1.5;
    /* min-height:55px; */
    margin-bottom: 10px;
    font-family: 'Ubuntu', sans-serif;
  }

  .MuiTypography-body2 {
    color: #555555;
    line-height: 1.8;
    margin-bottom: 10px;
    display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1199px) {
    height: 76px;
  }
  @media (max-width: 599px) {
    height: auto;
  }
  }

  .MuiButtonBase-root {
    min-width: 157px;
    padding: 10px;

    .MuiTypography-button {
        font-size: 14px;
        font-weight: 500;

        img {
            margin-right: 7px;
            border-radius: 0;
        }
    }
  }
`

const ServiceCard = styled(Box)`
    padding-top: 40px;

    .people-inr {
        img {
            border-radius: 20px;
        }
    }
`

const EnqueryDialog = styled(Box)`
    text-align: center;

    .MuiTypography-body1 {
        max-width: 756px;
        margin: 0 auto 45px;
    }
    .MuiTextField-root {
        width: 100%;

        &:not(:last-child) {
        margin-bottom: 30px;
        }

        input {
        box-sizing: border-box;
        height: 70px;

        @media (max-width: 599px) {
            height: 50px;
        }
        }

        .MuiInputLabel-root {
        /* transform: translate(14px, 22px) scale(1); */
        color: #65676A;
        font-weight: 400;
        font-size: 16px;
        padding-top: 8px;

        /* @media (max-width: 599px) {
            transform: translate(14px, 14px) scale(1);
        }

        &.Mui-focused {
            transform: translate(14px, -9px) scale(0.75);
        } */
        &.MuiInputLabel-shrink {
        padding-top: 0;
      }
        }

        .Mui-focused {
        .MuiOutlinedInput-notchedOutline {
            border-color: rgba(0, 0, 0, 0.23);
            border-width: 1px;
        }
        }
    }

    .MuiButtonBase-root {
        width: 100%;
        margin-top: 45px;
    }
`

const ModalCloseBtn = styled(Button)`
    position: absolute;
    right: 15px;
    top: 15px;
    color: #1E294C;
    margin: 0 !important;
    width: auto !important;
    padding: 0;
    min-width: 1px;

    &:hover {
        background-color: #fff !important;
    }
`

const sliderLoop = [

    {
        sliderContent: "Individual and group sessions by a licensed clinical therapist.",
        authorImage: `${assest.client01}`,
        authorName: 'Therapy (coming soon)',
    },
    {
        sliderContent: "Build social and life skills with our program’s counseling staff.",
        authorImage: `${assest.client02}`,
        authorName: ' Life & Social Skills',
    },
    // {
    //     sliderContent: "Developing a specific plan of action (ISP).",
    //     authorImage: `${assest.client03}`,
    //     authorName: 'Treatment Planning & Case Management',
    // },
    // {
    //     sliderContent: "Weekly outings planned by both residents and staff.",
    //     authorImage: `${assest.client04}`,
    //     authorName: 'Recreational Exposure',
    // },
    {
        sliderContent: "Weekly outings planned by both residents and staff.",
        authorImage: `${assest.client05}`,
        authorName: 'Recreational Activities',
    },
    // {
    //     sliderContent: "Care from the best in the industry",
    //     authorImage: `${assest.client06}`,
    //     authorName: 'Direct Support Professional (DSP)',
    // },

]

const index = () => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <Wrapper>
            <Seo title="Services" canonical={""} description={""} url={""} image={""} />
            <CommonHeaderInner name="Services" pageName="Service" />
            <ServiceWrapper className='cmn_gap'>
                <Container fixed>
                    <ServiceHeading>
                        <Typography variant="h2" className="cmn-head">
                            Our <span>Services</span>
                        </Typography>
                        <Typography variant="body1">
                            Our services are highly personalized and focussed. We care and will not stop until our clients are 100% happy
                        </Typography>
                    </ServiceHeading>
                    <ServiceCard sx={{ flexGrow: 1 }}>
                        <Grid container spacing={4}>
                            {sliderLoop.map((item, index) => {
                                return (
                                    <Grid item md={4} sm={6} xs={12}>
                                        <Box className="people-slide" key={index}>
                                            <Box className="people-inr">
                                                <Image src={item.authorImage} width={358} height={394} layout="responsive" alt={"Image"} priority />
                                                <AuthorPaper>
                                                    <Typography variant="h3">{item.authorName}</Typography>
                                                    <Typography variant="body2">{item.sliderContent}</Typography>
                                                    {/* <CustomButton type="button" onClick={handleClickOpen}>
                                                        <Typography variant="button">
                                                            <Image src={assest.btnimg} alt="btn" width={16} height={16} />
                                                            Learn More
                                                        </Typography>
                                                    </CustomButton> */}
                                                </AuthorPaper>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </ServiceCard>
                </Container>
            </ServiceWrapper>
            <WhatPeopleSay />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className='expDialog'
            >
                <EnqueryDialog>
                    <ModalCloseBtn onClick={handleClose}>
                        <CancelIcon />
                    </ModalCloseBtn>
                    <Typography variant="h2" className="cmn-head">
                        Get <span>Started</span>
                    </Typography>
                    {/* <Typography variant="body1">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis feugiat sem at dui tempor, ac tristique sapien posuere. Aliquam vel sagittis erat.
                    </Typography> */}
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField id="outlined-basic" label="Name" />
                                <TextField id="outlined-basic" label="Email" />
                                <TextField id="outlined-basic" label="Phone" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Message"
                                    multiline
                                    rows={10.3}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <CustomButton type="button"><Typography variant="button">Start</Typography></CustomButton>
                </EnqueryDialog>
            </Dialog>
        </Wrapper>
    )
}

export default index